<template>
    <structure>
        <section class="message">
            <div class="box">
                <div class="icon">
                    <i class="fal fa-lock-alt"></i>
                </div>
                <div class="title">
                    <h1>{{title}}</h1>
                </div>
                <div class="text" v-html="text">
                </div>
            </div>
        </section>
    </structure>
</template>

<script>
    import structure from '@/templates/private'
    export default {
        components: { structure },
        data() {
            return {
                title: 'Mensagem',
                text: 'texto',
            }
        },
        methods: {
           
        },
        mounted(){
            this.title = this.$route.params.title
            this.text = this.$route.params.text
        },
        created(){
            
            
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
